<ng-container *transloco="let t; prefix: 'edit-chapter-modal'">

  <app-edit-modal-shell
    [activeTabId]="activeId()"
    (activeTabIdChange)="changeTab($event)"
    [field]="formGroup"
    [translocoPrefix]="'edit-chapter-modal'"
    [title]="t('title')"
    (close)="close()"
    (save)="save()"
    >
    <ng-template #title>
      {{t('title')}} <app-entity-title [libraryType]="libraryType()" [entity]="chapter()" [prioritizeTitleName]="false" />
    </ng-template>

    <!-- General Tab -->
    <ng-template [appEditTab]="Tabs.General">
      @if (accountService.hasAdminRole()) {
        <div class="row">
          <div class="col-md-9 col-sm-12 mb-3">
            <app-setting-item [title]="t('title-label')" [showEdit]="false" [toggleOnViewClick]="false" [control]="formGroup.titleName">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.titleName">
                  <input class="form-control" [formField]="formGroup.titleName" type="text"
                         [appFormField]="formGroup.titleName">
                </app-lockable-field>
              </ng-template>
            </app-setting-item>

          </div>

          <div class="col-md-3 col-sm-12 mb-3">
            <app-setting-item [title]="t('sort-order-label')" [showEdit]="false" [toggleOnViewClick]="false" [control]="formGroup.sortOrder">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.sortOrder">
                  <input class="form-control" [formField]="formGroup.sortOrder" type="number" step="0.1" inputmode="numeric"
                         [appFormField]="formGroup.sortOrder">
                </app-lockable-field>
              </ng-template>
            </app-setting-item>
          </div>
        </div>

        <div class="row">
          <div class="col-md-9 col-sm-12 mb-3">
            <app-setting-item [title]="t('isbn-label')" [showEdit]="false" [toggleOnViewClick]="false" [control]="formGroup.isbn">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.isbn">
                  <input class="form-control" [formField]="formGroup.isbn" type="text"
                         [appFormField]="formGroup.isbn">
                </app-lockable-field>
              </ng-template>
            </app-setting-item>
          </div>

          <div class="col-md-3 col-sm-12 mb-3">
            <app-setting-item [title]="t('age-rating-label')" [showEdit]="false" [toggleOnViewClick]="false" [control]="formGroup.ageRating">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.ageRating">
                  <app-setting-select [options]="ageRatings()" [formField]="formGroup.ageRating">
                    <ng-template #template let-ar>
                      {{ar | ageRating}}
                    </ng-template>
                  </app-setting-select>
                </app-lockable-field>
              </ng-template>
            </app-setting-item>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9 col-md-12">
            <div class="mb-3">
              @let langConfig = languageSettings();
              <app-setting-item [title]="t('language-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.language">
                <ng-template #view>
                  <app-typeahead (selectedData)="updateLanguage($event)" [config]="langConfig"
                                 [(locked)]="locks.language">
                    <ng-template #badgeItem let-item>
                      {{item.title}}
                    </ng-template>
                    <ng-template #optionItem let-item>
                      {{item.title}} ({{item.isoCode}})
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            </div>
          </div>

          <div class="col-lg-3 col-md-12">
            <div class="mb-3">
              <app-setting-item [title]="t('release-date-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.releaseDate">
                <ng-template #view>
                  <app-lockable-field [(locked)]="locks.releaseDate">
                    <input class="form-control" [formField]="formGroup.releaseDate"
                      type="date" [appFormField]="formGroup.releaseDate"
                    />
                  </app-lockable-field>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="mb-3" style="width: 100%">
            <app-setting-item [title]="t('summary-label')" [showEdit]="false" [toggleOnViewClick]="false" [control]="formGroup.summary">
              <ng-template #view>
                <app-lockable-field [(locked)]="locks.summary">
                  <textarea id="summary" class="form-control" [formField]="formGroup.summary" [appFormField]="formGroup.summary" rows="4"></textarea>
                </app-lockable-field>
              </ng-template>
            </app-setting-item>
          </div>
        </div>
      }
    </ng-template>

    <!-- Tags Tab -->
    @if (accountService.hasAdminRole()) {
      <ng-template [appEditTab]="Tabs.Tags">
        <!-- genre & tag -->
        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @let genreConf = genreSettings();
              <app-setting-item [title]="t('genres-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.genres">
                <ng-template #view>
                  <app-typeahead (selectedData)="updateGenres($event)" [config]="genreConf"
                                 [(locked)]="locks.genres">
                    <ng-template #badgeItem let-item>
                      {{item.title}}
                    </ng-template>
                    <ng-template #optionItem let-item>
                      {{item.title}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @let tagsConf = tagsSettings();
              <app-setting-item [title]="t('tags-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.tags">
                <ng-template #view>
                  <app-typeahead (selectedData)="updateTags($event)" [config]="tagsConf"
                                 [(locked)]="locks.tags">
                    <ng-template #badgeItem let-item>
                      {{item.title}}
                    </ng-template>
                    <ng-template #optionItem let-item>
                      {{item.title}}
                    </ng-template>
                  </app-typeahead>
                </ng-template>
              </app-setting-item>
            </div>
          </div>
        </div>

        <!-- imprint & publisher -->
        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if (getPersonsSettings(PersonRole.Imprint); as settings) {
                <app-setting-item [title]="t('imprint-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Imprint)"
                                   [config]="settings"
                                   [(locked)]="personLocks.imprintLocked">
                      <ng-template #badgeItem let-item>
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item>
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if (getPersonsSettings(PersonRole.Publisher); as settings) {
                <app-setting-item [title]="t('publisher-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Publisher)" [config]="settings"
                                   [(locked)]="personLocks.publisherLocked">
                      <ng-template #badgeItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>
        </div>

        <!-- team & location -->
        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if (getPersonsSettings(PersonRole.Team); as settings) {
                <app-setting-item [title]="t('team-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Team)" [config]="settings"
                                   [(locked)]="personLocks.teamLocked">
                      <ng-template #badgeItem let-item>
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item>
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if (getPersonsSettings(PersonRole.Location); as settings) {
                <app-setting-item [title]="t('location-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Location)" [config]="settings"
                                   [(locked)]="personLocks.locationLocked">
                      <ng-template #badgeItem let-item>
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item>
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>
        </div>

        <!-- character -->
        <div class="row">
          <div class="col-lg-12 col-md-12 pe-2">
            <div class="mb-3">
              @if (getPersonsSettings(PersonRole.Character); as settings) {
                <app-setting-item [title]="t('character-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Character)" [config]="settings"
                                   [(locked)]="personLocks.characterLocked">
                      <ng-template #badgeItem let-item>
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item>
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>
        </div>
      </ng-template>
    }

    <!-- People Tab -->
    @if (accountService.hasAdminRole()) {
      <ng-template [appEditTab]="Tabs.People">
        <!-- writer & cover artist -->
        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if (getPersonsSettings(PersonRole.Writer); as settings) {
                <app-setting-item [title]="t('writer-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Writer)" [config]="settings"
                                   [(locked)]="personLocks.writerLocked">
                      <ng-template #badgeItem let-item>
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item>
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if (getPersonsSettings(PersonRole.CoverArtist); as settings) {
                <app-setting-item [title]="t('cover-artist-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.CoverArtist)" [config]="settings"
                                   [(locked)]="personLocks.coverArtistLocked">
                      <ng-template #badgeItem let-item>
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item>
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>
        </div>

        <!-- penciller & colorist -->
        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if(getPersonsSettings(PersonRole.Penciller); as settings) {
                <app-setting-item [title]="t('penciller-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Penciller)" [config]="settings"
                                   [(locked)]="personLocks.pencillerLocked">
                      <ng-template #badgeItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if(getPersonsSettings(PersonRole.Colorist); as settings) {
                <app-setting-item [title]="t('colorist-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Colorist)" [config]="settings"
                                   [(locked)]="personLocks.coloristLocked">
                      <ng-template #badgeItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>
        </div>

        <!-- inker & letterer -->
        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if(getPersonsSettings(PersonRole.Inker); as settings) {
                <app-setting-item [title]="t('inker-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Inker)" [config]="settings"
                                   [(locked)]="personLocks.inkerLocked">
                      <ng-template #badgeItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if(getPersonsSettings(PersonRole.Letterer); as settings) {
                <app-setting-item [title]="t('letterer-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Letterer)" [config]="settings"
                                   [(locked)]="personLocks.lettererLocked">
                      <ng-template #badgeItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>
        </div>

        <!-- editor & translator -->
        <div class="row">
          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if(getPersonsSettings(PersonRole.Editor); as settings) {
                <app-setting-item [title]="t('editor-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Editor)" [config]="settings"
                                   [(locked)]="personLocks.editorLocked">
                      <ng-template #badgeItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pe-2">
            <div class="mb-3">
              @if(getPersonsSettings(PersonRole.Translator); as settings) {
                <app-setting-item [title]="t('translator-label')" [toggleOnViewClick]="false" [showEdit]="false">
                  <ng-template #view>
                    <app-typeahead (selectedData)="updatePerson($event, PersonRole.Translator)" [config]="settings"
                                   [(locked)]="personLocks.translatorLocked">
                      <ng-template #badgeItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                      <ng-template #optionItem let-item let-position="idx">
                        {{item.name}}
                      </ng-template>
                    </app-typeahead>
                  </ng-template>
                </app-setting-item>
              }
            </div>
          </div>
        </div>
      </ng-template>
    }

    <!--External Metadata Ids-->
    @if (accountService.hasAdminRole()) {
      <ng-template [appEditTab]="Tabs.ExternalMetadataIds">
        <app-edit-external-metadata-form [field]="formGroup"/>
      </ng-template>
    }

    <!-- Cover Tab -->
    @if (accountService.hasAdminRole()) {
      <ng-template [appEditTab]="Tabs.CoverImage">
        <p class="alert alert-warning" role="alert">
          {{t('cover-image-description')}}
        </p>
        <app-cover-image-chooser [config]="chooserConfig()" (coverChanged)="handleCoverChanged($event)" (resetClicked)="handleReset()" />
      </ng-template>
    }

    <!-- Info Tab -->
    <ng-template [appEditTab]="Tabs.Info">
      <div class="row">
        <div class="col-lg-6 col-md-12 pe-2">
          <div class="mb-3">
            <app-setting-item [title]="t('pages-label')" [toggleOnViewClick]="false" [showEdit]="false">
              <ng-template #view>
                {{t('pages-count', {num: chapter().pages | compactNumber})}}
              </ng-template>
            </app-setting-item>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pe-2">
          <div class="mb-3">
            <app-setting-item [title]="t('words-label')" [toggleOnViewClick]="false" [showEdit]="false">
              <ng-template #view>
                {{t('words-count', {num: chapter().wordCount | compactNumber})}}
              </ng-template>
            </app-setting-item>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12 pe-2">
          <div class="mb-3">
            <app-setting-item [title]="t('read-time-label')" [toggleOnViewClick]="false" [showEdit]="false">
              <ng-template #view>
                {{chapter() | readTime }}
              </ng-template>
            </app-setting-item>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pe-2">
          <div class="mb-3">
            <app-setting-item [title]="t('size-label')" [toggleOnViewClick]="false" [showEdit]="false">
              <ng-template #view>
                {{size() | bytes}}
              </ng-template>
            </app-setting-item>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-6 col-md-12 pe-2">
          <div class="mb-3">
            <app-setting-item [title]="t('date-added-label')" [toggleOnViewClick]="false" [showEdit]="false">
              <ng-template #view>
                {{chapter().createdUtc | utcToLocalTime:'short' | defaultDate}}
              </ng-template>
            </app-setting-item>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pe-2">
          <div class="mb-3">
            <app-setting-item [title]="t('id-label')" [toggleOnViewClick]="false" [showEdit]="false">
              <ng-template #view>
                {{chapter().id}}
              </ng-template>
            </app-setting-item>
          </div>
        </div>
      </div>


      @if (weblinks().length > 0) {
        <div class="setting-section-break"></div>

        <div class="container-fluid mb-3">
          <div class="row">
            <h6 class="section-title">{{t('links-label')}}</h6>
            <div class="col-auto">
              @for(link of weblinks(); track link) {
                <a class="me-1" [href]="link | safeHtml" target="_blank" rel="noopener noreferrer" [title]="link">
                  <app-image height="24px" width="24px" aria-hidden="true" [imageUrl]="imageService.getWebLinkImage(link)"
                             [errorImage]="imageService.errorWebLinkImage" />
                </a>
              }
            </div>
          </div>
        </div>
      }

      @if (accountService.hasAdminRole()) {
        <div class="row">
          <app-setting-item [title]="t('files-label')" [toggleOnViewClick]="false" [showEdit]="false">
            <ng-template #view>
              @for (file of chapter().files; track file.id) {
                <div>
                  <span>{{file.filePath}}</span><span class="dot-separator mx-2"></span><span>{{file.bytes | bytes}}</span>
                </div>
              }
            </ng-template>
          </app-setting-item>
        </div>
      }
    </ng-template>


    <!-- Tasks Tab -->
    <ng-template [appEditTab]="Tabs.Tasks">
      @for(task of tasks(); track task.action) {
        @if (accountService.canCurrentUserInvokeAction(task.action)) {
          <div class="mt-3 mb-3">
            <app-setting-button [subtitle]="task.description">
              <button type="button" class="btn btn-{{task.action === Action.Delete ? 'danger' : 'secondary'}} btn-sm mb-2" (click)="runTask(task)">{{task.title}}</button>
            </app-setting-button>
          </div>
        }
      }
    </ng-template>

  </app-edit-modal-shell>

</ng-container>
